<template>
  <div class="page">
    <div class="bg-content padding15 m-b-24">
      <!-- <el-tabs v-model="activeName">
        <el-tab-pane label="发送中" name="first">
          <message-sending v-bind:changeTabe="activeName"></message-sending>
        </el-tab-pane>
        <el-tab-pane label="待发送" name="second">
          <message-witeSend v-bind:changeTabe="activeName"></message-witeSend>
        </el-tab-pane>
        <el-tab-pane label="发送失败" name="third">
          <message-failSend v-bind:changeTabe="activeName"></message-failSend>
        </el-tab-pane>
      </el-tabs> -->
      <div class="padding15-tb text right">
        <el-button type="primary" @click="getList" size="mini" plain> <i class="fa fa-search"></i> 搜索</el-button>
      </div>

       <p>
        <el-button icon="el-icon-refresh" type="primary" size="small" @click="resendSelectedCase">重启选中案件</el-button>
      </p>
      <br/>
      <el-table
        size="small"
        :data="list"
        border
        v-loading="loading"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          align="center">
        </el-table-column>
         <el-table-column
          property="companyName"
          label="公司"
          align="center">
        </el-table-column>
        <el-table-column
          property="batchNo"
          label="批次号"
          align="center">
        </el-table-column>
        <el-table-column
          property="groupName"
          label="策略组"
          align="center">
        </el-table-column>
        <el-table-column
          property="caseCount"
          label="条数"
          align="center">
        </el-table-column>
        <el-table-column
          property="failMessageId"
          label="操作"
          align="center">
          <template slot-scope="scope">
            <el-button type="text" size="medium" icon="el-icon-refresh" @click="resendCase(scope.row)">重启</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
// import MessageSending from './messageSending';
// import MessageWiteSend from './messageWiteSend';
// import MessageFailSend from './messageFailSend';

export default {
  data() {
    return {
      // activeName: 'first'
      list: [],
      loading: false,
      multipleSelection: []
    };
  },
  mounted() {
    // const type = sessionStorage.getItem('messageType');
    // if (type) {
    //   this.activeName = type;
    // }
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      this.$ajax({
        url: '/message/getList'
      }).then((res) => {
        console.warn(res);
        this.list = res.data;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    resendCase(row) {
      this.$confirm('', '确定要重启案件吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          prompt: true,
          url: '/message/resendCase',
          data: row
        }).then(() => {
          // this.getList();
        });
      });
    },
    resendSelectedCase() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: '请先选中需要启动的案子',
          type: 'warning'
        });
        return;
      }
      this.$confirm('', '确定要重启选中的案件吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          prompt: true,
          url: '/message/resendSelectedCase',
          data: this.multipleSelection
        });
      }).then(() => {
        this.getList();
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  }
  // components: {
  //   MessageSending, MessageWiteSend, MessageFailSend
  // }
};
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/page/main/message/list.vue